module.exports = __webpack_public_path__ + "static/img/brand_distributor.b4ef46c9.png";